import nvSorterColumnModule from '../../../sorter-column/nv.sorterColumn.module';

angular.module('nv.shared.services.sorter.agGrid', [nvSorterColumnModule]);
